import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TotalEasyToDriverCard from 'src/components/reports/reportsBoard/CommercialsReports/TotalEasyToDriverCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const EasyToDriverPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()
  return (
    <>
      <CardTitle
        title="Fáciles de manejar"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <TotalEasyToDriverCard
        titleCard="Mercado total fáciles de manejar"
        arrayTableAA={props.total}
        arrayTableAAPP={props.totalSegment}
        paramAAPP="SEGMENTO"
        selectedDate={selectedDate}
        arrayGraphBar={props.gTotal}
        arrayGraphA={props.gTotalA}
        arrayGraphB={props.gTotalB}
        pramGraphs="y"
      />
      <TotalEasyToDriverCard
        titleCard="Mercado fáciles de manejar MOPED"
        arrayTableAA={props.moped}
        arrayTableAAPP={props.mopedSegment}
        paramAAPP="SUBSEGMENTO"
        selectedDate={selectedDate}
        arrayGraphBar={props.gMoped}
        arrayGraphA={props.gmSegment}
        arrayGraphB={props.gMopedB}
        pramGraphs="Y"
      />
      <TotalEasyToDriverCard
        titleCard="Mercado fáciles de manejar SCOOTER"
        arrayTableAA={props.scooter}
        arrayTableAAPP={props.scooterSegment}
        paramAAPP="SUBSEGMENTO"
        selectedDate={selectedDate}
        arrayGraphBar={props.gTScooter}
        arrayGraphA={props.gScooterA}
        arrayGraphB={props.gScooterB}
        pramGraphs="Y"
      />
    </>
  )
}

export default EasyToDriverPage
